import { Component, EventEmitter, Output } from '@angular/core';
import {
    DialogDisclosureStatementDirective,
    DialogListDirective,
    DialogSectionHeaderDirective,
} from '../../../v2-layout/shared/dialogs/dialog.directive';
import { LinkButtonDirective } from '../../../v2-layout/shared/directives/button.directive';
import { STRIPE_DISCLOSURE_TEXT, STRIPE_URLS } from '../../../v2-layout/stripe-treasury/stripe-treasury.constants';

/**
 * Shared Stripe Connect onboarding intro content — copy, bullets, agreements list,
 * disclosure statement, and "Start Verification" button. Layout-agnostic so it can
 * be embedded in either a v2 (MatDialog) or v1 (MatLegacyDialog) dialog wrapper.
 */
@Component({
    selector: 'app-onboarding-intro-content',
    templateUrl: './onboarding-intro-content.component.html',
    styleUrls: ['./onboarding-intro-content.component.scss'],
    standalone: true,
    imports: [
        LinkButtonDirective,
        DialogListDirective,
        DialogSectionHeaderDirective,
        DialogDisclosureStatementDirective,
    ],
})
export class OnboardingIntroContentComponent {
    @Output() startVerification = new EventEmitter<void>();

    readonly stripeUrls = STRIPE_URLS;
    readonly disclosureText = STRIPE_DISCLOSURE_TEXT.PARTNER_DISCLOSURE;

    onStartVerification(): void {
        this.startVerification.emit();
    }
}
